import { styled, Tabs } from '@mui/material';

import colors from '../../Styling/Constants/colors';

export const TabsContainer = styled(Tabs)`
    border-bottom: 1px solid ${colors['light-gray']};
`;
